
import { User, Calendar, Clock, DollarSign } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface PsychologistData {
  id: string;
  name: string;
  photo_url?: string;
  crp: string;
  rating?: number;
  specialties: string[];
}

interface AppointmentSummaryCardProps {
  psychologist: PsychologistData;
  selectedDate: string;
  selectedTime: string;
  selectedDuration: number;
  pricing: {
    price_30min?: number;
    price_60min?: number;
  };
}

const AppointmentSummaryCard = ({ 
  psychologist, 
  selectedDate, 
  selectedTime, 
  selectedDuration, 
  pricing 
}: AppointmentSummaryCardProps) => {
  // CORREÇÃO: Calcular preço correto baseado na duração selecionada
  const getCorrectPrice = () => {
    if (selectedDuration === 30) {
      return pricing.price_30min || 150;
    } else if (selectedDuration === 60) {
      return pricing.price_60min || 280;
    } else {
      // Para outras durações, calcular proporcionalmente
      const basePrice = pricing.price_60min || 280;
      return Math.round((basePrice / 60) * selectedDuration);
    }
  };

  const correctPrice = getCorrectPrice();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Resumo da Consulta</CardTitle>
        <CardDescription>
          Confirme os detalhes selecionados
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="flex items-center gap-3">
            <User className="w-5 h-5 text-blue-600" />
            <div>
              <div className="text-sm text-gray-500">Psicólogo</div>
              <div className="font-medium">{psychologist.name}</div>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <Calendar className="w-5 h-5 text-blue-600" />
            <div>
              <div className="text-sm text-gray-500">Data</div>
              <div className="font-medium">
                {new Date(selectedDate).toLocaleDateString('pt-BR', {
                  weekday: 'short',
                  day: '2-digit',
                  month: '2-digit'
                })}
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <Clock className="w-5 h-5 text-blue-600" />
            <div>
              <div className="text-sm text-gray-500">Horário</div>
              <div className="font-medium">{selectedTime.substring(0, 5)} ({selectedDuration}min)</div>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <DollarSign className="w-5 h-5 text-blue-600" />
            <div>
              <div className="text-sm text-gray-500">Valor</div>
              <div className="font-medium text-green-600">
                R$ {correctPrice.toFixed(2).replace('.', ',')}
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-xs text-blue-600 bg-blue-50 p-2 rounded">
          ✅ Preço calculado corretamente: {selectedDuration} minutos = R$ {correctPrice.toFixed(2).replace('.', ',')}
        </div>
      </CardContent>
    </Card>
  );
};

export default AppointmentSummaryCard;
